import { useMemo } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PartyPopper } from "lucide-react";

const COLORS = ["#9F583F", "#D79A66", "#4d7c3f", "#E9B949", "#C0704E", "#1C1917"];

const CelebGiraffe = () => (
  <svg width="110" height="150" viewBox="0 0 120 200" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M48 96 C45 130 43 165 42 200 L82 200 C80 165 77 130 73 96 Z" fill="#D79A66" stroke="#1C1917" strokeWidth="3" strokeLinejoin="round" />
    <ellipse cx="54" cy="128" rx="7" ry="8" fill="#9F583F" />
    <ellipse cx="70" cy="150" rx="7" ry="8" fill="#9F583F" />
    <ellipse cx="52" cy="172" rx="6" ry="7" fill="#9F583F" />
    <line x1="49" y1="60" x2="47" y2="40" stroke="#1C1917" strokeWidth="3" strokeLinecap="round" />
    <line x1="71" y1="60" x2="73" y2="40" stroke="#1C1917" strokeWidth="3" strokeLinecap="round" />
    <circle cx="46" cy="37" r="6" fill="#9F583F" stroke="#1C1917" strokeWidth="3" />
    <circle cx="74" cy="37" r="6" fill="#9F583F" stroke="#1C1917" strokeWidth="3" />
    <ellipse cx="34" cy="70" rx="10" ry="6" fill="#D79A66" stroke="#1C1917" strokeWidth="3" transform="rotate(-25 34 70)" />
    <ellipse cx="86" cy="70" rx="10" ry="6" fill="#D79A66" stroke="#1C1917" strokeWidth="3" transform="rotate(25 86 70)" />
    <ellipse cx="60" cy="82" rx="25" ry="27" fill="#D79A66" stroke="#1C1917" strokeWidth="3" />
    <ellipse cx="60" cy="98" rx="17" ry="13" fill="#EAD9C6" stroke="#1C1917" strokeWidth="2.5" />
    <circle cx="54" cy="98" r="1.6" fill="#1C1917" />
    <circle cx="66" cy="98" r="1.6" fill="#1C1917" />
    {/* big happy smile */}
    <path d="M52 102 Q60 110 68 102" stroke="#1C1917" strokeWidth="2.2" fill="none" strokeLinecap="round" />
    {/* happy closed eyes */}
    <path d="M47 80 Q51 76 55 80" stroke="#1C1917" strokeWidth="2.6" fill="none" strokeLinecap="round" />
    <path d="M65 80 Q69 76 73 80" stroke="#1C1917" strokeWidth="2.6" fill="none" strokeLinecap="round" />
    {/* cheeks */}
    <circle cx="45" cy="92" r="3.5" fill="#E79A82" opacity="0.7" />
    <circle cx="75" cy="92" r="3.5" fill="#E79A82" opacity="0.7" />
  </svg>
);

const Confetti = () => {
  const pieces = useMemo(
    () =>
      Array.from({ length: 70 }).map((_, i) => ({
        id: i,
        left: Math.random() * 100,
        color: COLORS[i % COLORS.length],
        delay: Math.random() * 0.5,
        duration: 2.2 + Math.random() * 1.6,
        rotate: Math.random() * 720 - 360,
        w: 6 + Math.random() * 8,
        h: 8 + Math.random() * 8,
        drift: Math.random() * 60 - 30,
      })),
    []
  );
  return (
    <div className="fixed inset-0 pointer-events-none z-[60] overflow-hidden" aria-hidden="true">
      {pieces.map((p) => (
        <motion.div
          key={p.id}
          initial={{ y: -60, x: 0, opacity: 1, rotate: 0 }}
          animate={{ y: "112vh", x: p.drift, rotate: p.rotate, opacity: 1 }}
          transition={{ duration: p.duration, delay: p.delay, ease: "easeIn" }}
          style={{
            position: "absolute",
            left: `${p.left}%`,
            width: p.w,
            height: p.h,
            background: p.color,
            borderRadius: 2,
          }}
        />
      ))}
    </div>
  );
};

export const CelebrationGiraffe = ({ active }) => (
  <AnimatePresence>
    {active && (
      <div key="celebration" data-testid="celebration-giraffe">
        <Confetti />
        <motion.div
          initial={{ y: 220, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 220, opacity: 0 }}
          transition={{ type: "spring", stiffness: 120, damping: 13 }}
          className="fixed bottom-0 left-1/2 -translate-x-1/2 z-[60] pointer-events-none flex flex-col items-center"
        >
          <div className="mb-2 inline-flex items-center gap-2 bg-white border border-[#E7E5E4] shadow-md px-4 py-2 rounded-2xl font-body text-sm text-[#1C1917]">
            <PartyPopper size={16} className="text-[#9F583F]" />
            Grazie del commento!
          </div>
          <motion.div
            animate={{ rotate: [0, -5, 5, -5, 0] }}
            transition={{ duration: 0.8, repeat: 2 }}
          >
            <CelebGiraffe />
          </motion.div>
        </motion.div>
      </div>
    )}
  </AnimatePresence>
);
